<button *ngIf="!isOpenedChatLayer" class="button-primary button-rounded open-button" type="button" (click)="onclickOpenChat()">
    <i class="ri-customer-service-line"></i>
</button>